import PropTypes from 'prop-types';
import get from 'lodash/get';

const useDebugHandler = (props) => {
  const { initOptions } = props;

  /**
   * Normally we use the learnosity api to handle backend requests, however they use window.location.hostname in their
   * requests to their backend. Turns out thats pretty well the only modification for any signed requests. So we can just
   * use this function, and use whatever domain we want, and it seems to work.
   *
   * This is used solely for local development, not to be used for higher environments. Only works for reports api.
   * @param {*} initOptions signed request from the backend/
   * @param {*} handlers ui callbacks
   */
  const devLearnosityInit = (initOptions, handlers) => {
    const handlersWithDefaults = {
      errorListener: () => {},
      dataListener: () => {},
      readyListener: () => {},
      ...handlers,
    };
    const url = 'https://reports-va.learnosity.com/v2023.2.LTS/init';

    // using fetch because it doesn't include any of our axios configurations
    fetch(url, {
      method: 'POST',
      mode: 'cors',
      body: new URLSearchParams({
        security: JSON.stringify(initOptions.security),
        request: JSON.stringify(initOptions.request),
        action: 'get',
      }),
      headers: {
        // learnosity expects the request to specifically be url encoded
        // IE body looks like `action=get&security=...`
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    })
      .then(async (response) => {
        handlersWithDefaults.readyListener();
        handlersWithDefaults.dataListener((await response.json()).data);
      })
      .catch(handlersWithDefaults.errorListener);
    return {
      destroy: () => {},
      reset: () => {},
    };
  };

  const isDifferentDomain =
    OVERRIDE_SSO_LOGIN &&
    get(initOptions, 'security.domain') !== window.location.hostname;

  return {
    isDifferentDomain,
    devLearnosityInit,
  };
};

useDebugHandler.propTypes = {
  initOptions: PropTypes.object.isRequired,
};

export default useDebugHandler;
